var SpriteSymbol = require("../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
var symbol = new SpriteSymbol({
  "id": "home-active",
  "use": "home-active-usage",
  "viewBox": "0 0 20 17",
  "content": "<symbol viewBox=\"0 0 20 17\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"home-active\">\n    <title>Shape</title>\n    <g id=\"home-active_New-Client-Application-Screens\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g id=\"home-active_0.1.0-Dashboard-No-Applications\" transform=\"translate(-20.000000, -117.000000)\">\n            <g id=\"home-active_Group-11\" transform=\"translate(0.000000, 100.000000)\">\n                <g id=\"home-active_Group-7\">\n                    <g id=\"home-active_Group\" transform=\"translate(20.000000, 16.000000)\" fill=\"#FFFFFF\" fill-rule=\"nonzero\">\n                        <polygon id=\"home-active_Shape\" points=\"8 18 8 12 12 12 12 18 17 18 17 10 20 10 10 1 0 10 3 10 3 18\" />\n                    </g>\n                </g>\n            </g>\n        </g>\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
module.exports = "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/home-active.svg
// module id = vUaV
// module chunks = 1